module.exports = __webpack_public_path__ + "img/card-bg4.d23427e1.png";